import apiHeader from '@/helpers/apiHeader';

const serviceAdvanceService = {
    search(params) {
        return apiHeader.post('navbar/advance-search-service/search', params);
    },

    getServiceDetail(serviceNumber) {
        return apiHeader.get(`navbar/advance-search-service/${serviceNumber}`);
    }
}

export default serviceAdvanceService;